export const routePaths = {
  LOGIN: "/login", //home page of application when user is logged out
  REGISTER: "/register", //signup page
  RESET_REQUEST: "/reset-request", //reset request
  RESET_FORM: "/reset-form/:token", // reset final form
  AUTH_OTP: "/verify-otp", //2-factor Authentication for login
  LANDING: "/landing", //landing page (reuseable)
  LOGIN_VIA_OTP: "/login/login-via-otp", //login via otp page
  QUICK_PAY: "/quick-pay",
  VIEW_BALANCE: "/view-balance",
  PAYMENT: "/payment-quickpay",
  PAYMENT_BILLPAY: "/path/payment/billpay",
  PAYMENT_BILLPAY: "/payment/billpay",
  TERMS_CONDITION: "/terms-condition",
  RETRY: "/service-unavailable",
  NSA: "/new-service-agreement",
  BILL_PAY: "/path/bill-pay",
  SEARCH_RESULTS: "/path/search-results",
  BILL_PAY: "/bill-pay",
  SEARCH_RESULTS: "/search-results",
  FAQS: "/faqs",
  ANNOUNEMENT:"/announcements",
  FORGOT_PASSWORD:"/login/forgot-password",
  SIGN_UP_VERIFICATION_FAIL:"/sign-up/verification-failed",
  SIGN_UP_VERIFY_OTP:"/sign-up/verify-otp",
  SIGN_UP_ACCOUNT_ACTIAVTION:"/sign-up/account-activation",
  ACTIVATE_EMAIL:"/sign-up/activate-email",
  LOGIN_VERIFY_OTP: "/login/verify-otp",
  NCR:"/new-connection-request",
  TRACK_REQUEST:"/track-request",
  TRACK_REQUEST_STEPS:"/track-request-steps",
  MIGRATE_USER:'/user-migration',
  ONE_TIME_PAYMENTS:'/one-time-payment',
  PRIVACY_POLICY:'/privacy-policy'
};
